export const convertDate = (date) => {
    let dummy_date = new Date(date);
    return (
        dummy_date.getHours().toString().padStart(2, '0') +
        ':' +
        dummy_date.getMinutes().toString().padStart(2, '0') +
        ' ' +
        dummy_date.getFullYear() +
        '/' +
        (dummy_date.getMonth() + 1).toString().padStart(2, '0') +
        '/' +
        dummy_date.getDate().toString().padStart(2, '0')
    );
};

export const isDateGreaterThan30Days = (targetDate) => {
    if (!targetDate) {
        return false;
    }
    // Get the current date
    const currentDate = new Date();

    // Create a new date representing 30 days ago
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(currentDate.getDate() - 30);

    // Compare the target date with the date from 30 days ago
    return new Date(targetDate) < thirtyDaysAgo;
};

export const convertMinuteNumberToHoursAndDays = (minute, isLeft) => {
    const isLeftTextAtEnd = isLeft ? 'left' : '';
    if (minute < 59) {
        if (minute === 0) {
            return 'Closed';
        } else {
            const rminutes = Math.floor(minute);
            const remainderMinutes = Math.round(minute % 60);
            return remainderMinutes > 0
                ? `${rminutes + 1} ${rminutes >= 1 && remainderMinutes > 0 ? 'mins' : 'min'} ${isLeftTextAtEnd}`
                : `${rminutes} ${rminutes >= 1 && remainderMinutes > 0 ? 'mins' : 'min'} ${isLeftTextAtEnd}`;
        }
    } else if (minute > 59 && minute < 1399) {
        const hours = minute / 60;
        const rhours = Math.floor(hours);
        const remainderHours = Math.round(hours % 24);
        if (remainderHours > 0) return `${rhours + 1} ${rhours >= 1 && remainderHours > 0 ? 'hours' : 'hour'} ${isLeftTextAtEnd}`;
        else {
            return `${rhours} ${rhours >= 1 && remainderHours > 0 ? 'hours' : 'hour'} ${isLeftTextAtEnd}`;
        }
    } else {
        const hours = minute / 60;
        const days = Math.floor(hours / 24);
        const remainderHours = Math.round(hours % 24);
        if (remainderHours > 0) return `${days + 1} ${days >= 1 && remainderHours > 0 ? 'days' : 'day'} ${isLeftTextAtEnd}`;
        else return `${days} ${days >= 1 && remainderHours >= 0 ? 'hours' : 'hour'} ${isLeftTextAtEnd}`;
    }
};

export const formatDateToDDMMYYYYHHMMSS = (date) => {
    const newDate = new Date(date);
    const day = String(newDate.getDate()).padStart(2, '0');
    const month = String(newDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = newDate.getFullYear();
    const hours = String(newDate.getHours()).padStart(2, '0');
    const minutes = String(newDate.getMinutes()).padStart(2, '0');
    const seconds = String(newDate.getSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

export const formatDateToHHMMDDMMYYYY = (date) => {
    const newDate = new Date(date);
    const day = String(newDate.getDate()).padStart(2, '0');
    const month = String(newDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = newDate.getFullYear();
    const hours = String(newDate.getHours()).padStart(2, '0');
    const minutes = String(newDate.getMinutes()).padStart(2, '0');

    return `${hours}:${minutes} ${day}/${month}/${year}`;
};

export const formatDateToDDMMYYYY = (date) => {
    const newDate = new Date(date);
    const day = String(newDate.getDate()).padStart(2, '0');
    const month = String(newDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = newDate.getFullYear();
    return `${day}/${month}/${year}`;
};

export const formatDateToDMYYYY = (date) => {
    const newDate = new Date(date);
    const day = String(newDate.getDate()).padStart(2, '');
    const month = String(newDate.getMonth() + 1).padStart(2, ''); // Months are zero-based
    const year = newDate.getFullYear();
    return `${day}/${month}/${year}`;
};

export const formatDateTODayHHMMM = (date) => {
    const currentDate = new Date(date);
    const options = { weekday: 'long', hour: 'numeric', minute: 'numeric', hour12: true };
    const formattedResult = currentDate.toLocaleString('en-US', options).toLowerCase();
    return formattedResult;
};

export const formatDateRange = (startDateTime, endDateTime, isAllDay) => {
    var options = { weekday: 'short', day: 'numeric', month: 'numeric', year: 'numeric' };
    const newStartDate = new Date(startDateTime);
    const newEndDate = new Date(endDateTime);
    if (isAllDay) {
        // All-day event, only show date
        var formattedStartDate = newStartDate.toLocaleString('en-US', {
            weekday: 'short',
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
        });
        var formattedEndDate = newEndDate.toLocaleString('en-US', { weekday: 'short', day: 'numeric', month: 'numeric', year: 'numeric' });
        return formattedStartDate + ' - ' + formattedEndDate;
    } else {
        // Same start and end date

        var formattedDate = newStartDate.toLocaleString('en-US', options);
        var formattedTimeRange =
            newStartDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' }) +
            ' - ' +
            newEndDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        return formattedDate + ' | ' + formattedTimeRange;
    }
};
export const getDateAfter30Seconds = () => {
    const currentDate = new Date();
    currentDate.setSeconds(currentDate.getSeconds() + 30);
    return currentDate;
};

export const sortByDate = (a, b) => {
    // const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const dateA = new Date(a.date.replace(/(\w+) (\d+)/, '$1 01 $2'));
    const dateB = new Date(b.date.replace(/(\w+) (\d+)/, '$1 01 $2'));

    return dateB - dateA;
};
export const sortByDateWithTime = (a, b) => {
    // const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return new Date(b.date).getTime() - new Date(a.date).getTime();
};
export const formatTime = (seconds) => {
    if (seconds >= 3600) {
        // Convert seconds to hours
        const hours = Math.round(seconds / 3600);
        const remainingSeconds = seconds % 3600;
        const minutes = Math.round(remainingSeconds / 60);
        return `${hours} hour${hours > 1 ? 's' : ''} ${minutes} minute${minutes > 1 ? 's' : ''}`;
    } else if (seconds >= 60) {
        // Convert seconds to minutes
        const minutes = Math.round(seconds / 60);
        return `${minutes} minute${minutes > 1 ? 's' : ''}`;
    } else if (seconds >= 2) {
        // Show seconds
        return `${Math.round(Number(seconds))} seconds`;
    } else if (seconds === 1 || seconds === 0 || seconds > 0) {
        // Show 1 second if seconds is 1 or 0
        return '1 second';
    } else {
        return `Calculating time...`;
    }
};
